<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
    <div class="card bd-gray-400">
      <table
        class="table mg-b-0 table-contact product-table supplier data-table"
      >
        <thead>
          <tr>
            <th class="wd-lg-30">
              <label class="ckbox mg-b-0">
                <input
                  type="checkbox"
                  :checked="allCheck"
                  @change="allCheckChange"
                />
                <span></span>
              </label>
            </th>
            <th class="wd-50"></th>
            <th>{{ $t("product.商品") }}sku</th>
            <th class="wd-lg-200">{{ $t("product.已绑定库存") }}SKU</th>
            <th class="wd-lg-200">
              {{ $t("product.创建") }} / {{ $t("product.最近更新时间") }}
            </th>
            <th class="wd-lg-150">{{ $t("product.操作") }}</th>
          </tr>
        </thead>
        <tbody v-for="(item, index) in items" :key="item.id + index">
          <tr>
            <td class="valign-middle">
              <label class="ckbox mg-b-0">
                <input type="checkbox" :value="item.sku" v-model="checkArr" />
                <span></span>
              </label>
            </td>
            <td class="td-collapse" :class="{ active: openInner[index] }">
              <div
                class="pd-5"
                v-if="
                  item.propertyType != '1' &&
                  item.propertyName != '' &&
                  item.productStocks.length > 0
                "
              >
                <a href="javascript:;" @click="innerTableStatus(index)">
                  <i
                    class="fa tx-white"
                    :class="
                      openInner[index] ? 'fa-minus-square' : 'fa-plus-square'
                    "
                  ></i>
                </a>
              </div>
            </td>
            <td class="valign-middle">
              <div class="d-flex align-items-center">
                <!--<a class="p-img-wrap" :href="item.type == 2 ? item.a1688DetailUrl : 'javascript:;'" target="_blank" :style="{backgroundImage: 'url('+ (item.majorImageUrl ? item.majorImageUrl:'img/none-img.png') +')', backgroundSize: scale[index].scale ? 'auto 100%':'100%'}">
                </a>-->
                <a
                  v-if="item.productStocks && item.productStocks.length == 1"
                  class="p-img-wrap"
                  href="javascript:;"
                  :data-i="index"
                  v-lazy:background-image="item.productStocks[0].propertyImage"
                  style="background-size: cover"
                  @click="preview('spu', item)"
                >
                </a>
                <a
                  v-else
                  class="p-img-wrap"
                  href="javascript:;"
                  v-lazy:background-image="item.majorImageUrl"
                  style="background-size: cover"
                  @click="preview('spu', item)"
                >
                </a>
                <div class="p-info">
                  <p>
                    <a
                      class="tx-ellipsis2 tx-info"
                      :href="
                        item.type == 2 ? item.a1688DetailUrl : 'javascript:;'
                      "
                      :target="item.type == 2 ? '_blank' : '_self'"
                    >
                      {{ item.name }}
                    </a>
                  </p>
                  <p>
                    {{ $t("product.销售") }}SKU{{ $t("product.编号") }}:
                    <span class="tx-white">{{ item.sku }}</span>
                  </p>
                  <p v-if="item.type == 2">
                    (1688){{ $t("product.编号") }}:
                    <span class="tx-white">{{ item.outerItemId }}</span>
                  </p>
                  <p v-if="item.propertyName">
                    {{ $t("product.属性值") }}:
                    <span class="tx-white">{{
                      formatProp(item.propertyName)
                    }}</span>
                  </p>
                  <p v-if="item.inventoryStock && item.inventoryStock.sku">
                    {{ $t("product.库存") }}SKU{{ $t("product.编号") }}:
                    <span class="tx-white">{{ item.inventoryStock.sku }}</span>
                  </p>
                </div>
              </div>
            </td>
            <td class="valign-middle">
              <span
                v-if="
                  item.propertyType == 1 ||
                  (item.propertyType != 1 &&
                    item.productStocks &&
                    item.productStocks.length == 1)
                "
                :class="{
                  'tx-white': item.inventoryStock && item.inventoryStock.sku,
                }"
                >{{
                  item.inventoryStock && item.inventoryStock.sku
                    ? $t("product.是")
                    : $t("product.否")
                }}</span
              >
            </td>
            <td class="valign-middle">
              <p class="mg-b-5">
                {{ $t("product.创建") }}：<span class="tx-white">
                  {{
                    item.timeCreated ? timeFormat_1(item.timeCreated) : "---"
                  }}</span
                >
              </p>
              <p class="mg-b-0">
                {{ $t("product.更新") }}：<span class="tx-white">
                  {{
                    item.timeLastUpdate
                      ? timeFormat_1(item.timeLastUpdate)
                      : "---"
                  }}</span
                >
              </p>
            </td>
            <td
              v-if="$route.query.source == 'new-products'"
              class="valign-middle"
            >
              <div
                v-if="
                  !(
                    item.propertyType != '1' &&
                    item.propertyName != '' &&
                    item.productStocks.length > 0
                  )
                "
              >
                <a
                  class="btn btn-info btn-sm tx-12"
                  href="javascript:;"
                  @click="selectNewProduct(item.sku)"
                  >{{ $t("product.选为新品推荐") }}</a
                >
              </div>
            </td>
            <td
              v-if="$route.query.source == 'edit-product'"
              class="valign-middle"
            >
              <div
                v-if="
                  !(
                    item.propertyType != '1' &&
                    item.propertyName != '' &&
                    item.productStocks.length > 0
                  )
                "
              >
                <a
                  class="btn btn-info btn-sm tx-12"
                  href="javascript:;"
                  @click="selectEditProduct(item)"
                  >{{ $t("product.选为要编辑商品") }}</a
                >
              </div>
            </td>
            <td v-else class="valign-middle">
              <p
                v-if="$route.meta.url == '/s-product' && item.status == 1"
                class="mg-b-0"
              >
                <a class="tx-info" href="javascript:;" @click="outPro(index)">{{
                  $t("product.下架")
                }}</a>
              </p>
              <p
                v-if="$route.meta.url == '/s-product' && item.status == 2"
                class="mg-b-0"
              >
                <a class="tx-info" href="javascript:;" @click="upPro(index)">{{
                  $t("product.上架")
                }}</a>
              </p>
              <p
                v-if="
                  $route.meta.url == '/s-product' &&
                  userInfo.notSupplyChangeProduct != 1
                "
                class="mg-b-0"
              >
                <a
                  class="tx-info"
                  href="javascript:;"
                  @click="openModalEditPro(index)"
                  >{{ $t("product.修改") }}</a
                >
              </p>
              <p v-if="$route.meta.url == '/s-product'" class="mg-b-0">
                <a
                  class="tx-info"
                  href="javascript:;"
                  @click="delProModal(index)"
                  >{{ $t("product.删除") }}</a
                >
              </p>
            </td>
          </tr>
          <tr
            v-if="
              item.propertyType != '1' &&
              item.propertyName != '' &&
              item.productStocks.length > 0
            "
            :style="{ display: openInner[index] ? 'table-row' : 'none' }"
          >
            <td class="inner-wrap" colspan="6">
              <table
                class="
                  table
                  mg-b-0
                  table-contact
                  product-table-inner
                  data-table
                "
              >
                <tbody>
                  <tr
                    v-for="(stock, stockIndex) in item.productStocks"
                    :key="stock.id"
                  >
                    <td class="wd-lg-30 border-top-0"></td>
                    <td
                      class="wd-50 sub-td-collapse"
                      :class="{ active: openInner[index] }"
                    ></td>
                    <td class="">
                      <div class="d-flex align-items-center">
                        <!--<a class="p-img-wrap" href="javascript:;" :style="{backgroundImage: 'url('+ (stock.propertyImage ? stock.propertyImage:'img/none-img.png') +')', backgroundSize: (scale[index].sub[stockIndex]) ? 'auto 100%':'100%'}">
                        </a> -->
                        <a
                          class="p-img-wrap"
                          href="javascript:;"
                          :data-i="index"
                          :data-j="stockIndex"
                          v-lazy:background-image="stock.propertyImage"
                          style="background-size: cover"
                          @click="preview('sku', item, stockIndex)"
                        >
                        </a>
                        <div class="p-info">
                          <p>
                            SKU:
                            <span class="tx-white mg-r-5">{{ stock.sku }}</span>
                            <a
                              v-show="stock.sku"
                              class="to-clipboard tx-info mg-l-5"
                              href="javascript:;"
                              :data-clipboard-text="stock.sku"
                            >
                              <i class="icon ion-clipboard"></i>
                            </a>
                          </p>
                          <p class="tx-ellipsis1">
                            Spec:
                            <span class="tx-white">{{ stock.specId }}</span>
                          </p>
                          <p>
                            {{ $t("product.属性") }}:
                            <span
                              class="tx-white"
                              v-html="formatProp(stock.propertyValue)"
                            ></span>
                          </p>
                          <p
                            v-if="
                              stock.inventoryStock && stock.inventoryStock.sku
                            "
                            class="tx-ellipsis1"
                          >
                            {{ $t("product.库存") }}SKU{{ $t("product.编号") }}:
                            <span class="tx-white">{{
                              stock.inventoryStock.sku
                            }}</span>
                          </p>
                        </div>
                      </div>
                    </td>
                    <td class="wd-lg-200 valign-middle">
                      <span
                        :class="{
                          'tx-white':
                            stock.inventoryStock && stock.inventoryStock.sku,
                        }"
                        >{{
                          stock.inventoryStock && stock.inventoryStock.sku
                            ? $t("product.是")
                            : $t("product.否")
                        }}</span
                      >
                    </td>
                    <td class="wd-lg-150 valign-middle">
                      <p class="mg-b-0 tx-white">
                        <span>{{ stock.price }}</span>
                      </p>
                    </td>
                    <td></td>
                    <td
                      v-if="$route.query.source == 'new-products'"
                      class="wd-lg-150 valign-middle"
                    >
                      <a
                        class="btn btn-info btn-sm tx-12"
                        href="javascript:;"
                        @click="selectNewProduct(stock.sku)"
                        >{{ $t("product.选为新品推荐") }}</a
                      >
                    </td>
                    <td
                      v-if="$route.query.source == 'edit-product'"
                      class="wd-lg-150 valign-middle"
                    >
                      <a
                        class="btn btn-info btn-sm tx-12"
                        href="javascript:;"
                        @click="selectEditProduct(stock)"
                        >{{ $t("product.选为要编辑商品") }}</a
                      >
                    </td>
                    <td v-else class="wd-lg-150 valign-middle">
                      <p
                        v-if="
                          $route.meta.url == '/s-product' && stock.status == 1
                        "
                        class="mg-b-0"
                      >
                        <a
                          class="tx-info"
                          href="javascript:;"
                          @click="outPro(index, stockIndex)"
                          >{{ $t("product.下架") }}</a
                        >
                      </p>
                      <p
                        v-if="
                          $route.meta.url == '/s-product' && stock.status == 2
                        "
                        class="mg-b-0"
                      >
                        <a
                          class="tx-info"
                          href="javascript:;"
                          @click="upPro(index, stockIndex)"
                          >{{ $t("product.上架") }}</a
                        >
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
        <tbody v-if="(!items || items.length < 1) && !first_loading">
          <tr>
            <td colspan="7">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i>{{ $t("product.没有符合条件的商品") }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  props: ["items", "first_loading", "isAccordion", "check_arr"],
  data() {
    return {
      openInner: [],
      scale: [],
      checkArr: [],
      userInfo: "",
    };
  },
  computed: {
    allCheck() {
      return this.checkArr.length == this.items.length &&
        this.checkArr.length > 0
        ? true
        : false;
    },
  },
  watch: {
    isAccordion: function () {
      //$t('product.展开折叠')
      this.openInnerFormat();
    },
    items: {
      handler: function () {
        //      this.imgScale();
        this.openInnerFormat();
        this.userInfo = store.get("userInfo");
      },
      deep: true,
    },
    check_arr: function () {
      this.checkArr = this.check_arr;
    },
    checkArr: function () {
      this.$emit("changeCheck", this.checkArr);
    },
  },
  methods: {
    preview(type, item, index) {
      index++;
      this.$parent.loading = true;
      let multi = () => {
        arrImg.push({ img: item.majorImageUrl, text: item.name });
        item.productStocks.forEach((stock) => {
          arrImg.push({ img: stock.propertyImage, text: stock.sku });
        });
        this.$store.commit("setImgItem", arrImg);
      };
      let arrImg = [];
      if ("spu") {
        //spu
        if (item.productStocks.length <= 1) {
          //spu$t('product.只有一个')sku
          this.$store.commit("setImgItem", [
            {
              img: item.productStocks.length
                ? item.productStocks[0].propertyImage
                : item.majorImageUrl,
              text: item.name,
            },
          ]);
        } else {
          //spu$t('product.有多个')sku
          multi();
        }
      } else if ("sku") {
        multi();
      }
      setTimeout(() => {
        const viewer = document.querySelector(".app-images-arr").$viewer;
        if (viewer.images.length) {
          if (index) {
            viewer.view(index);
          } else {
            viewer.show();
          }
        }
        this.$parent.loading = false;
      }, 500);
    },
    mergeProTemp(i, t) {
      this.$emit("mergeProTemp", i, t);
    },
    copyToSaleSku(type, id) {
      this.$parent.loading = true;
      let params = {};
      if (type == "spu") {
        params.productId = id;
      } else {
        params.stockId = id;
      }
      $.api_call("api.SupplierCrawlProduct.copyToSaleSku", params, (r) => {
        this.$parent.loading = false;
        if (r.ErrorCode == "9999") {
          ShowTip(this.$t("product.复制成功"), "success");
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    copyStoragePro(i, t) {
      this.$emit("copyStoragePro", i, t);
    },
    batchStoragePro(i, t) {
      this.$emit("batchStoragePro", i, t);
    },
    selectNewProduct(sku) {
      localStorage.setItem("selectNewProductSKU", sku);
      window.close();
    },
    selectEditProduct(item) {
      store.set("setSelectEditProduct", item);
      window.close();
    },
    timeFormat_1(val) {
      return moment(val, "YYYY-MM-DD h:mm:ss").format("YYYY-MM-DD");
    },
    delProModal(i, t) {
      this.$emit("delProModal", i, t);
    },
    outPro(i, subI) {
      this.$emit("outPro", i, subI);
    },
    upPro(i, subI) {
      this.$emit("upPro", i, subI);
    },
    formatProp(prop) {
      if (!prop) return;
      return prop.replace(/\|\|/g, ", ");
    },
    formatStatus(status) {
      if (status == 1) {
        return this.$t("product.在售中");
      } else if (status == 2) {
        return this.$t("product.已下架");
      }
      return "---";
    },
    openInnerFormat() {
      this.openInner = [];
      for (let i = 0; i < this.items.length; i++) {
        this.openInner.push(false);
        if (
          this.items[i].propertyType != "1" &&
          this.items[i].propertyName != "" &&
          this.items[i].productStocks.length > 0
        ) {
          this.openInner[i] = !this.isAccordion;
        }
      }
    },
    innerTableStatus(i) {
      this.$set(this.openInner, i, !this.openInner[i]);
    },
    imgScale() {
      this.scale = [];
      let vm = this;
      if (this.items && this.items.length > 0) {
        for (let i = 0; i < this.items.length; i++) {
          this.scale.push({ scale: false, sub: [] });
          if (this.items[i].majorImageUrl) {
            let img = new Image();
            img.src = this.items[i].majorImageUrl;
            img.onload = function () {
              if (img.width > img.height) {
                if (vm.scale && vm.scale.length > 0) {
                  vm.$set(vm.scale[i], "scale", true);
                }
              }
            };
          }
          if (
            this.items[i].propertyType != "1" &&
            this.items[i].propertyName != "" &&
            this.items[i].productStocks.length > 0
          ) {
            for (let j = 0; j < this.items[i].productStocks.length; j++) {
              this.scale[i].sub.push(false);
              if (this.items[i].productStocks[j].propertyImage) {
                let img = new Image();
                img.src = this.items[i].productStocks[j].propertyImage;
                img.onload = function () {
                  if (img.width > img.height) {
                    if (vm.scale[i].sub && vm.scale[i].sub.length > 0) {
                      vm.$set(vm.scale[i].sub, j, true);
                    }
                  }
                };
              }
            }
          }
        }
      }
    },
    allCheckChange() {
      if (this.allCheck) {
        this.checkArr = [];
      } else {
        this.checkArr = [];
        this.items.forEach((e) => {
          this.checkArr.push(e.sku);
        });
      }
    },
    openModalEditPro(index) {
      this.$emit("openModalEditPro", index);
    },
  },
};
</script>

